import { Directive, HostBinding } from '@angular/core';

@Directive()
// Abstract Base class
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class MuiTabsBase {
  @HostBinding('class.mui-tabs') readonly _muiBaseClass = true;
}
